<template>
      <img data-v-7211449b="" data-v-c9bcc182="" :src="skinTheme==2?'assets/images/score/scroll_top_02.svg':'assets/images/score/scroll_top_01.svg'" class="list-scroll-to-top"  @click="backToTop()">
</template>


<script>
import {
    mapGetters
  } from 'vuex'

  export default {
      computed: {
        ...mapGetters([
          'sportTableLang',
          'skinTheme'
        ]),
      },
      methods: {
        backToTop(){
            $(".scroll").animate({ scrollTop: 0 },100);
            $("#sportTable>div").animate({ scrollTop: 0 },100);
            $(".vue-recycle-scroller").animate({ scrollTop: 0 }, 100);
	          $("#expandSportTable>div").animate({scrollTop: 0},100);
        },
        showhideTop(){
            var pos = $( window ).scrollTop();
            if( pos == 0 ){
              $('.list-scroll-to-top').css({ 'display' : 'none' });
            }else{
              $('.list-scroll-to-top').css({ 'display' : 'block' });
            }
        },
      }, beforeMount: function () {
          $( window ).scroll(function(res) {
            this.showhideTop()
          }.bind(this));
      },


  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// resources/score/vue/apps/core/backToTop.vue